import { ErrorsCode } from 'src/app/models/enums/errorsCode';
import { IReservationRestrictionWarning } from 'src/app/models/booking/restrictionWarning';

// Both spellings: the same body reaches callers over HTTP and, one per booking, over the progress socket
export function restrictionWarningsOf(error: unknown): IReservationRestrictionWarning[] {
  const payload = error as {
    error_code?: number;
    errorCode?: number;
    entityInfo?: unknown;
    entity_info?: unknown;
  };
  const errorCode = payload?.error_code ?? payload?.errorCode;
  if (errorCode !== ErrorsCode.RESTRICTIONS_NOT_ACCEPTED) return [];
  const warnings = payload.entityInfo ?? payload.entity_info;
  return Array.isArray(warnings) ? (warnings as IReservationRestrictionWarning[]) : [];
}

// Several bookings of a batch can step over the same restriction, and the user is asked about it once
export function mergeRestrictionWarnings(
  warnings: IReservationRestrictionWarning[],
): IReservationRestrictionWarning[] {
  const byReason = new Map<string, IReservationRestrictionWarning>();
  warnings.forEach((warning) => {
    const merged = byReason.get(warning.reason);
    if (!merged) {
      byReason.set(warning.reason, {
        reason: warning.reason,
        affectedReservations: [...(warning.affectedReservations ?? [])],
      });
      return;
    }
    (warning.affectedReservations ?? []).forEach((affected) => {
      const alreadyListed = merged.affectedReservations.some(
        (listed) =>
          listed.reservationId === affected.reservationId &&
          listed.serviceAvailabilityStopId === affected.serviceAvailabilityStopId,
      );
      if (!alreadyListed) merged.affectedReservations.push(affected);
    });
  });
  return [...byReason.values()];
}
